export default __webpack_public_path__ + "/public/icons/jayson-bakonyi.jpeg";